<template>
  <div>
    <v-dialog v-if="uploadEPLDialog" v-model="uploadEPLDialog" width="700">
      <v-card>
        <v-card-title>
          Import MixCode File
        </v-card-title>
        <v-card-text>
          <v-form-file @uploaded="uploadEPL" label="Item File"
                       target="ofd"
                       accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                       return-url
                       xx-large></v-form-file>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn :loading="$store.getters.loading['SIZE_IMPORT']" @click="importConfirm"
                 color="primary" tile>OK
          </v-btn>
          <v-btn @click="uploadEPLDialog=false" outlined tile>CANCEL
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-page-data-table
        title="MixSize Rule"
        key-name="id"
        :fields="fields"
        ref="container"
        @create="onDetail"
        @import="importEPL"
        :show-edit="false"
        :show-delete="isAdmin"
        :row-actions="rowActions"
        :toolbar-actions="toolActions"
        query-api="MIX_CODE_QUERY">

      <template v-slot:containerNo="{item}">
        <v-link-text :text="item.containerNo" @click="onDetail(item)"></v-link-text>
      </template>
      <template v-slot:status="{item}">
        <v-btn text tile color="success" small v-if="item.status=='COMPLETED'">
          <v-icon small>mdi-checkbox-marked-circle</v-icon>
          {{ item.status }}
        </v-btn>
        <v-btn text tile color="success" small v-else-if="item.status=='NEW'">
          {{ item.status }}
        </v-btn>
      </template>
    </v-page-data-table>
  </div>
</template>

<script>
import MixCodeQueryFields from "./fields/MixCodeQueryFields";

export default {
  name: "ContainerQuery",
  data() {
    return {
      uploadEPLDialog: false,
      fields: MixCodeQueryFields,
      fileUuid: null,
      blNo:null,
      isAdmin:false,
      items: [
      ],
      rowActions: [],
      toolActions: [
        {
          text: 'upload',
          color: 'primary',
          icon: "mdi-upload",
          accessRole:'SMS_ADMIN',
          action: 'import'
        }
      ]
    }
  },
  created() {
    this.isAdmin=this.$tool.hasRole("SMS_ADMIN");
  },
  methods: {
    onDetail(item) {
      let id = item ? item.id : undefined;
      this.$router.apmRoute("docDetail", {id: id});
    },
    importEPL() {
      this.uploadEPLDialog = true;
    },
    uploadEPL(items) {
      if (items && items.length > 0) {
        this.fileUuid = items[0].uuid;
      }
    },
    importConfirm() {
      this.$request.request("MIX_CODE_IMPORT", {fileUuid: this.fileUuid}).then((response) => {
        this.$message.success("Import success");
        this.uploadEPLDialog = false;
        this.$refs.container.query();
      });
    }
  }
}
</script>
